import styled from 'styled-components'
import { CardText } from '../PageFooter/Footer.styled'
import externalLinkIcon from '../../asset/external-link-blue.svg'

export const FooterContainer = styled.div`
  color: #ffffff;
`

export const Header = styled.div`
  background: #0d414d;
  padding: 13px 0 13px 16px;

  display: flex;
  align-items: center;
`

export const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 20px;

  font-style: normal;
  line-height: 24px;
`

export const LinkBody = styled.div`
  background: #0d414d;
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  padding-bottom: 10px;
`

export const Link = styled.a`
  color: #ffffff;
  margin-bottom: 14px;
  width: fit-content;
  text-decoration: underline;
`

export const FooterContent = styled.div`
  background: #0a323c;
  padding: 2rem 16px 1.5rem 16px;
`

export const FooterCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border-bottom: 1px solid #ffffff;
`

export const CardIcon = styled.img``

export const CardContent = styled(CardText)`
  padding: 0 2rem 1.5rem 2rem;
  & > p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    & > a {
      color: #61daff;
      :after {
        background-image: url(${externalLinkIcon});
        background-size: 13px 13px;
        height: 13px;
        width: 13px;
      }
    }
  }
`

export const FooterBottom = styled.div`
  padding: 1rem 1rem 0 0;
  font-size: 15px;
`
